import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  IResponsiveRepeaterProps,
  IResponsiveRepeaterControllerProps,
  IResponsiveRepeaterStateRefValues,
} from '../ResponsiveRepeater.types';

export default withCompController<
  IResponsiveRepeaterProps,
  IResponsiveRepeaterControllerProps,
  IResponsiveRepeaterProps,
  IResponsiveRepeaterStateRefValues
>(({ mapperProps, stateValues }) => {
  const { experiments = {} } = stateValues;
  const shouldPauseMediaInNonActiveSlides = isExperimentOpen(
    experiments,
    'specs.thunderbolt.SlideshowStopMediaInNonActiveSlides',
  );
  const shouldAddRoleGroup = isExperimentOpen(
    experiments,
    'specs.thunderbolt.responsiveContainerRoleGroup',
  );
  return {
    ...mapperProps,
    shouldPauseMediaInNonActiveSlides,
    shouldAddRoleGroup,
    observeChildListChange: mapperProps.isMasterPage
      ? stateValues.observeChildListChangeMaster
      : stateValues.observeChildListChange,
  };
});
